import React from 'react';
import SelectPatient from './SelectPatient';
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";

class NoProxy extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ProxyPicker.NoProxy.Load", new Date(), Tools.getURLPath());
    }

    actionTaken = (skipProxy = false) => {
        const { savePreference, onActionTaken } = this.props;
        if (skipProxy && savePreference) {
            logUI("MBHWeb.UI.ProxyPicker.NoProxy.Skip.Clicked", new Date(), Tools.getURLPath());
            savePreference();
        } else {
            logUI("MBHWeb.UI.ProxyPicker.NoProxy.MySelf.Clicked", new Date(), Tools.getURLPath());
        }
        if (onActionTaken) {
            onActionTaken(true);
        }
    }

    render() {
        const { myProxies, message, patients, fromEvisit, currentUser, switchToMyChartUser, location, backToCalender, skipPatientInfo, iconLeftClass, steptitle, goNext, serverData, isMammography, goToApptInfo, apptInfoStepValue, goToNewStep, pickerInfo, savePreference, enableNewMammogramJourneyChanges } = this.props;
        return (<div className="no-proxy-container" style={this.props.style}>
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <SelectPatient message={message} myProxies={myProxies} patients={patients} location={location} pickerInfo={pickerInfo} skipPatientInfo={skipPatientInfo} backToCalender={backToCalender} currentUser={currentUser} switchToMyChartUser={switchToMyChartUser} isMammography={isMammography}
                            fromEvisit={fromEvisit} onClicked={this.actionTaken} iconLeftClass={iconLeftClass} removeActive steptitle={steptitle} goNext={goNext}
                            className={"col-12"} serverData={serverData} newUserSelected={this.props.newUserSelected} onUserSelected={this.props.onUserSelected} goToApptInfo={goToApptInfo}
                            apptInfoStepValue={apptInfoStepValue} goToNewStep={goToNewStep} fromNoProxy={true} savePreference={savePreference} enableNewMammogramJourneyChanges={enableNewMammogramJourneyChanges}
                        />
                    </div>
                </div>
            </div>
        </div>);
    }

}


export default NoProxy;